export enum Environment {
  PROD = 'prod',
  BETA = 'beta',
  RECETTE = 'recette',
}
